import { TTheme } from '@/core/theme'
import { ActionButton } from '@/ui/components/buttons/action'
import { styled } from '@mui/system'

export const TopSection = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 36px 80px;
`

export const IconWrapper = styled('div')`
    margin: 10px 0;
`

export const ToggleWrapper = styled('div')`
    height: 24px;
    width: fit-content;
`

export const StyledActionButton = styled(ActionButton)`
    width: 156px;
    height: 24px;
    font-size: var(--font-size-xs);
    padding: 0;
    margin-bottom: 20px;
`

export const TitleWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const ErrorWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 18px;
    color: ${({ theme: { colors } }) => colors.semantic.error};
`

